module.exports = __webpack_public_path__ + "img/account-icon-big.dceebac8.svg";